// import image from "../../assets/svgs/clay_phone_13_pro_max_mockup.png";
import { FaAmbulance, FaOilCan, FaPhoneSquare } from "react-icons/fa";
import { GiAutoRepair, GiPoliceCar } from "react-icons/gi";
import "./AdvantagesSection.scss";
import { Button } from "antd";
function AdvantagesSection() {
  return (
    <div
      className="advantages-wrapper home-section-wrapper"
      id="advantages-section"
    >
      <div className="container">
        <h3 className="page-title">الميزات </h3>
        {/* <Link to="/cars"> */}
        {/* </Link> */}
        <div className="advantages-content">
          <div className="advantages-list-holder">
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>ضمان الوكيل</p>
            </a>
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>الضمان الممتد</p>
            </a>
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>الضمان القانوني</p>
            </a>
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>ارقام تهمك</p>
            </a>
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>الصيانه</p>
            </a>
            <a href="tel:+0112450388" className="advantage-card-holder">
              <p>الارشادات و التعليمات</p>
            </a>
          </div>
        </div>
        <div className="phone-order-section" id="contact-section">
          <h3 className="page-title">اطلب عبر الهاتف المجاني </h3>
          <a href="tel:+8001234567">
            {" "}
            8001234567
            <FaPhoneSquare />
          </a>
        </div>
      </div>
    </div>
  );
}

export default AdvantagesSection;
